import { AUTHENTICATION_PROVIDER, AUTHENTICATION_URL_PARAMS, AuthType, forgeRefreshTokenCookie, } from '@innovyze/stylovyze/lib/types';
import AboutBox from '@innovyze/stylovyze/lib/components/AboutBox';
import { AbsoluteDiv, ButtonChild, InlineDiv, MenuElement, RelativeDiv, StyledMenu, } from './UserProfile.styles';
import { MenuItem, Link as MuiLink } from '@mui/material';
import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAdpAnalytics, useGlobalization, useSiteConfig, } from '@innovyze/stylovyze/lib/contexts';
import { AboutIcon } from '../icons/AboutIcon';
import ArrowIcon from '../icons/ArrowIcon';
import AutodeskPortalIcon from '../icons/AutodeskPortalIcon';
import FeedbackLinesIcon from '../icons/FeedbackLinesIcon';
import LogoutIcon from '../icons/LogoutIcon';
import PermIdentity from '@mui/icons-material/PermIdentity';
import RoundButton from '@innovyze/stylovyze/lib/components/RoundButton/RoundButton';
import cookies from 'browser-cookies';
import { getAuthenticationProvider } from '@innovyze/stylovyze/lib/utils/getAuthenticationProvider';
import { selectAuthenticationContext } from '@innovyze/stylovyze/lib/selectors';
import useLogoutRoute from '@innovyze/stylovyze/lib/hooks/useLogoutRoute';
import { userEndEmulation } from '@innovyze/stylovyze/lib/actions';
import { UserEmulationIcon } from '@innovyze/stylovyze/lib/icons/UserEmulation';
import { EndUserEmulationIcon } from '@innovyze/stylovyze/lib/icons/EndUserEmulation';
import WeavePicker from '../../../theme/WeavePicker';
import { useConsumeWeaveTheme } from '../../../theme/WeaveContext';
export const UserProfile = ({ aboutBox, hasLoginPicker, inEmulation, }) => {
    const { resolvedRoles, isWeaveTheme } = useConsumeWeaveTheme();
    const { config } = useSiteConfig();
    const isForgeFlow = getAuthenticationProvider() === AuthType.Forge;
    const { logout, user, client } = useSelector(selectAuthenticationContext);
    const { setLogoutRoute } = useLogoutRoute();
    const { t } = useGlobalization();
    const adp = useAdpAnalytics();
    const getLogoutRouteParams = (switchAccount) => {
        const authType = localStorage.getItem(AUTHENTICATION_PROVIDER);
        const hasForgeRefreshToken = cookies.get(forgeRefreshTokenCookie);
        if (switchAccount)
            return AUTHENTICATION_URL_PARAMS.PICKER;
        return authType === AuthType.Forge || hasForgeRefreshToken
            ? AUTHENTICATION_URL_PARAMS.AUTODESK
            : AUTHENTICATION_URL_PARAMS.AUTH0;
    };
    const logoutAction = ({ switchAccount }) => {
        const logoutRouteParams = getLogoutRouteParams(switchAccount);
        setLogoutRoute(logoutRouteParams);
        if (logout)
            logout(undefined, client);
    };
    const userName = user?.email ?? '';
    const menuAnchorRef = useRef(null);
    const [menuOpen, setMenuOpen] = React.useState(false);
    const [aboutBoxOpen, setAboutBoxOpen] = React.useState(false);
    const openMenu = () => setMenuOpen(true);
    const closeMenu = () => setMenuOpen(false);
    const dispatch = useDispatch();
    const textColor = isWeaveTheme && resolvedRoles['colorScheme.text.default']
        ? resolvedRoles['colorScheme.text.default']
        : 'white';
    const backgroundColor = isWeaveTheme && resolvedRoles['menu.backgroundColor']
        ? resolvedRoles['menu.backgroundColor']
        : '#43575d';
    return (React.createElement(InlineDiv, null,
        React.createElement(RoundButton, { onClick: openMenu, "data-cy": "" }, inEmulation ? (React.createElement(UserEmulationIcon, null)) : (React.createElement(PermIdentity, { htmlColor: textColor }))),
        React.createElement(RelativeDiv, null,
            React.createElement(AbsoluteDiv, { ref: menuAnchorRef })),
        React.createElement(StyledMenu, { MenuListProps: {
                style: {
                    borderRadius: 0,
                    margin: 0,
                    backgroundColor,
                    color: textColor,
                },
            }, PaperProps: {
                style: {
                    borderRadius: 0,
                },
            }, id: 'profile-menu', anchorEl: menuOpen ? menuAnchorRef.current : null, keepMounted: true, open: menuOpen, onClose: closeMenu },
            inEmulation && (React.createElement(MenuItem, null,
                React.createElement(MuiLink, { color: "inherit", underline: 'none' },
                    React.createElement(MenuElement, { onClick: e => {
                            e.preventDefault();
                            dispatch(userEndEmulation());
                            closeMenu();
                        } },
                        React.createElement(EndUserEmulationIcon, null),
                        React.createElement("span", null, t('End User Emulation')))))),
            aboutBox && (React.createElement(MenuItem, { title: aboutBox.title, onClick: () => setAboutBoxOpen(!aboutBoxOpen) },
                React.createElement(MenuElement, null,
                    React.createElement(AboutIcon, { color: textColor }),
                    ' ',
                    React.createElement("span", null, aboutBox.title)))),
            isForgeFlow && (React.createElement(MenuItem, { title: t('Click to manage Autodesk Account') },
                React.createElement(MuiLink, { href: config?.forge?.portalDomain
                        ? config?.forge?.portalDomain
                        : 'https://manage.autodesk.com/home', target: "_blank", rel: "noopener noreferrer", color: "inherit", underline: 'none' },
                    React.createElement(MenuElement, null,
                        React.createElement(AutodeskPortalIcon, { color: textColor }),
                        ' ',
                        React.createElement("span", null,
                            t('Autodesk Account'),
                            " ",
                            React.createElement(ArrowIcon, null)))))),
            React.createElement(MenuItem, { title: t('Click to provide feedback') },
                React.createElement(MuiLink, { href: "https://feedback.innovyze.com/forums/924217-info360-and-operational-analytics", target: "_blank", rel: "noopener noreferrer", color: "inherit", underline: 'none' },
                    React.createElement(MenuElement, null,
                        React.createElement(FeedbackLinesIcon, { color: textColor }),
                        ' ',
                        React.createElement("span", null, t('Provide Feedback'))))),
            React.createElement(MenuItem, { title: t('Click to sign out {{userName}}', { userName }) },
                React.createElement(MuiLink, { color: "inherit", underline: 'none' },
                    React.createElement(MenuElement, { onClick: e => {
                            e.preventDefault();
                            adp?.track('SESSION_END');
                            logoutAction({ switchAccount: false });
                            closeMenu();
                        } },
                        React.createElement(LogoutIcon, { color: textColor }),
                        ' ',
                        React.createElement("span", null, t('Log Out'))),
                    hasLoginPicker && (React.createElement(MenuElement, { onClick: e => {
                            e.preventDefault();
                            adp?.track('SESSION_END');
                            logoutAction({ switchAccount: true });
                            closeMenu();
                        } },
                        React.createElement("div", null),
                        React.createElement(ButtonChild, { type: "button", title: t('Click to switch your account') }, t('Sign in with a different domain')))))),
            React.createElement(WeavePicker, null)),
        aboutBox && (React.createElement(AboutBox, { ...aboutBox, open: aboutBoxOpen, setOpen: setAboutBoxOpen }))));
};
export default UserProfile;
